const presetDefault = {
    app_top_nav_bg_color: '#2d3436',
    app_home_color_primary: '#2d3436',
    app_home_color_secondary: '#f0bb5a',
    app_home_list_item_title_color:'#cf0721',
    app_home_list_item_subtitle_color:'#ec5f71',
    app_home_text_top_nav:'#ffffff',
    app_home_text_body_secondary:'#ec5f71',
    app_home_menu_category:'#cf0721',
    app_loading_icon_color:'red'
}

export default presetDefault